import { tagAction } from "../const";
export const getTag = (data: any) => {
    return {
        type: tagAction.GET_TAG,
        payload: data,
    };
};
